import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import { HandInStatementMutation } from '@/lib/gql/__generated__/canonical-documents';
import type { HandInStatementInput } from '@/lib/gql/__generated__/graphql';

export const handInStatementActor = fromPromise<boolean, HandInStatementInput>(async ({ input }) => {
  const result = await apolloClient.mutate({
    mutation: HandInStatementMutation,
    variables: {
      input: {
        fileRef: input.fileRef,
        filingId: input.filingId,
        statementId: input.statementId,
      },
    },
  });

  if (!result.data?.handInStatement.success) {
    throw new Error(result.data?.handInStatement.error?.message ?? 'The statement could not be handed in.');
  }
  return true;
});
